import React from "react";
import { CalendarDays, Clock, ClipboardList, X } from "lucide-react";

export default function InfoPopupHeaderSection({ infoPopup }) {
  const { t, displayDate, displayTime, displayTimeUTC, onClose } = infoPopup;

  return (
    <section className="info-popup-modern-header">
      <div className="info-popup-title-row">
        <h3 className="info-popup-title">
          <span className="info-popup-title-icon" aria-hidden="true">
            <ClipboardList size={18} strokeWidth={2.25} />
          </span>
          <span>{t("catch_information")}</span>
        </h3>
        <button
          type="button"
          className="info-popup-header-close-btn"
          onClick={onClose}
          aria-label={t("close")}
        >
          <X size={18} strokeWidth={2.4} aria-hidden="true" />
        </button>
      </div>

      {(displayDate || displayTime) && (
        <div className="info-popup-section info-popup-section--date-time">
          <h4 className="info-popup-section-title">
            {t("info_popup_section_date_time")}
          </h4>
          <div className="info-popup-date-time-grid">
            {displayDate && (
              <div className="info-popup-mini-card">
                <span className="info-popup-mini-card-icon" aria-hidden="true">
                  <CalendarDays size={16} strokeWidth={2.25} />
                </span>
                <span className="info-popup-mini-card-copy">
                  <span className="info-popup-mini-card-label">{t("date")}</span>
                  <strong>{displayDate}</strong>
                </span>
              </div>
            )}

            {displayTime && (
              <div className="info-popup-mini-card">
                <span className="info-popup-mini-card-icon" aria-hidden="true">
                  <Clock size={16} strokeWidth={2.25} />
                </span>
                <span className="info-popup-mini-card-copy">
                  <span className="info-popup-mini-card-label">{t("time")}</span>
                  <strong>
                    {displayTime}
                    {displayTimeUTC && (
                      <> ({displayTimeUTC} {t("utc_time")})</>
                    )}
                  </strong>
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}
